<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <!-- <span class="hyper-link"  @click.stop="openLink" :title="fieldsInfo.fieldValue">{{ fieldsInfo.fieldValue }}</span> -->
  <fh-ellipsis @click.stop="openLink" :content="fieldsInfo?.fieldValue" :wrapHeight="params.rowHeight" class="link-text" />
  <!-- 腾讯官网定开需求 from xuedong start -->
  <jw-link v-if="fieldsInfo.entity == 228 && fieldsInfo?.fieldKey == 'web_url'" style="color: rgb(var(--link-6))" @click.stop="copyLink">{{ $t('复制') }}</jw-link>
</template>

<script setup>
import { computed } from 'vue';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import FhEllipsis from '@/components/fh-ellipsis/index.vue';
const { t } = useI18n();

const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
});
const fieldsInfo = computed(() => props.params);
const openLink = () => {
  try {
    window.open(fieldsInfo.value.fieldValue, '_blank');
  } catch (error) {
    Message.warning('无效链接');
    console.log('无效链接:', error);
  }
};

// 复制网址
const copyLink = async () => {
  try {
    await navigator.clipboard.writeText(fieldsInfo.value?.fieldValue);
    Message.success(t('复制成功'));
  } catch (err) {
    Message.error(t('复制失败'));
    console.log('复制失败', err);
  }
};
</script>
<style scoped lang="less">
@import './link.less';
</style>
